module.exports = __webpack_public_path__ + "static/media/purple-banana.3505d0a2.jpg";